import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import RequestServies from "../../../services/RequestServies";
import ProductServices from "../../../services/ProductServices";
import RequisitionForm from "./MivForm";
import MivForm from "./MivForm";
import Swal from 'sweetalert2'; // Import SweetAlert

const AddMivUsedItem = ({ onSuccess }) => {
  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [isModelOpen, setIsModelOpen] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const user = JSON.parse(localStorage.getItem("userDetails"));
  const availableStores = user?.data?.user?.store || [];
  const defaultStore = availableStores[0]?._id || "";

  const [stores, setStores] = useState(availableStores);
  const [selectedStore, setSelectedStore] = useState(defaultStore);

  const [requisition, setRequisiton] = useState('');
  const [selectedRequisition, setSelectedRequisiton] = useState('');
  const [run, setRun] = useState(0);

  const [items, setItems] = useState([
    { name: "", inventory: "", description: "", currentQty: '', usedQty: '', error: "", unit: "" },
  ]);
  const [partOptions, setPartOptions] = useState([]);
  const [item, setItem] = useState();

  const handleAddItem = (e) => {
    e.preventDefault();

    const lastItem = items[items.length - 1];

    // Check for required fields
    if (!lastItem || !lastItem.inventory || !lastItem.name || lastItem.usedQty <= 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Incomplete Item',
        text: 'Please fill in all fields (Inventory, Name, and Used Qty) before adding a new item.',
        confirmButtonText: 'OK'
      });
      return; // Exit if the last item doesn't have all required fields filled
    }
    setItems([
      ...items,
      { name: "", inventory: "", description: "", currentQty: '', usedQty: '', error: "", unit: "" },
    ]);
  };

  const handleItemChange = (index, field, value) => {
    console.log(value);
    const newItems = [...items];
    newItems[index][field] = value;

    if (field === "usedQty") {
      if (value > newItems[index].currentQty) {
        newItems[index].error = `Required Qty cannot be greater than eligible Qty`;
      } else if (value <= 0) {
        newItems[index].error = `Required Qty cannot be 0 or negative`;
      } else {
        newItems[index].error = "";
      }
    }
    console.log(newItems);
    setItems(newItems);
  };

  const handlePartSelect = (index, selectedOption) => {

    const isDuplicate = items.some(item => item.inventory === selectedOption.value);

    if (isDuplicate) {
      Swal.fire({
        icon: 'error',
        title: 'Duplicate Item',
        text: 'This item has already been added to the list.',
        confirmButtonText: 'OK'
      });
      return; // Exit the function if a duplicate is found
    }
    console.log(index, selectedOption);
    handleItemChange(index, "inventory", selectedOption.value);
    handleItemChange(index, "name", selectedOption.label);
    handleItemChange(index, "currentQty", selectedOption.currentStock);
    handleItemChange(index, "description", selectedOption.description); // Set description
    handleItemChange(index, "unit", selectedOption.unit); // Set unit
    handleItemChange(
      index,
      "eligible",
      selectedOption.currentStock
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let isValid = true;
    let errorMessage = "";

    items.forEach((item, index) => {
      if (item.usedQty > item.currentQty) {
        isValid = false;
        errorMessage = `Item ${index + 1}: Used Qty cannot be greater than Current Qty`;
      } else if (item.usedQty <= 0) {
        isValid = false;
        errorMessage = `Item ${index + 1}: Required Qty cannot be 0 or negative`;
      } else if (!selectedRequisition) {
        isValid = false;
        errorMessage = `Miv not selected !`;
      }
    });

    if (!isValid) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: errorMessage,
        confirmButtonText: 'OK'
      });
      return;
    }
    setIsSubmitting(true);
    const requestData = { mivId: selectedRequisition, items };

    console.log(requestData);
    RequestServies.submitMiv(requestData)
      .then((response) => {
        console.log('Submission successful:', response);
        // Show Swal success message
        Swal.fire({
          icon: 'success',
          title: 'Submission Successful',
          text: 'Your MIV Items has been submitted successfully!',
          confirmButtonText: 'OK'
        });
        setItems([
          { name: "", inventory: "", description: "", currentQty: '', usedQty: '', error: "", unit: "" },
        ]);
        setRun(run + 1);
      })
      .catch((error) => {
        console.log('Error during submission:', error);
        // Show Swal error message
        Swal.fire({
          icon: 'error',
          title: 'Submission Failed',
          text: 'An error occurred while submitting the requisition.',
          confirmButtonText: 'Try Again'
        });
        // Handle error feedback here
      }).finally(() => {
        setIsSubmitting(false); // Re-enable the button after response
      });
  };



  const handleRemoveItem = (e, index) => {
    e.preventDefault();
    const newItems = [...items];
    newItems.splice(index, 1);
    setItems(newItems);
  };

  // const handleAddItemSubmit = (event) => {
  //   event.preventDefault(); // Prevent form submission
  //   // Call your API to add the item
  //   const itemToAdd = items[items.length - 1]; // Assuming you're adding the last item
  //   itemToAdd.requisitionNo =  selectedRequisition;

  //   console.log(itemToAdd)
  //   RequestServies.createItem(itemToAdd) // Replace with your actual API call
  //     .then(response => {
  //       console.log('Item added successfully', response);
  //       onSuccess(); // Call the success callback if needed
  //     })
  //     .catch(error => {
  //       console.error('Error adding item', error);
  //     });
  // };

  useEffect(() => {
    if (selectedStore) {
      setItems([
        { name: "", inventory: "", description: "", currentQty: '', usedQty: '', error: "", unit: "" },
      ])
      const status = 'open'
      RequestServies.getMiv(selectedStore, status)
        .then((res) => {
          setRequisiton(res?.data?.data);
          setSelectedRequisiton(res?.data?.data[0]._id);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [selectedStore, run]);

  useEffect(() => {
    // Fetch parts options for the dropdown
    ProductServices.getInventory(selectedStore) // Assume this service returns a list of parts
      .then((res) => {
        console.log(res);
        const options = res.data.data.map((part) => ({
          value: part._id,
          label: part?.masterItem?.partNo,
          description: part?.masterItem?.description,
          currentStock: part?.currentStock,
          unit: part.masterItem?.unit?.name
        }));
        setPartOptions(options);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [selectedStore]);

  const handleStoreChange = (e) => {
    setSelectedStore(e.target.value);
    setSelectedRequisiton();
  };

  const handleRequsitionChange = (e) => {
    setSelectedRequisiton(e.target.value);
  };
  const handleRequisitionForm = (item) => {
    setIsModelOpen(true);
  };
  return (
    <>
      <MivForm
        show={isModelOpen}
        handleClose={() => setIsModelOpen(false)}
        store={stores}
        onSuccess={() => setRun(prev => prev + 1)}
      />
      <div className="row">
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fas fa-filter me-2"></i>Filter
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                  onClick={() => setOpen(!open)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-4 col-xxl-4">
                      <label>Select Store</label>
                      <select
                        className="form-select mb-xl-0 mb-3"
                        value={selectedStore}
                        onChange={handleStoreChange}
                      >
                        {stores.map((store) => (
                          <option key={store._id} value={store._id}>
                            {store.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-xl-4 col-xxl-4">
                      <label>Select Material Issue Voucher No.</label>
                      <select
                        className="form-select mb-xl-0 mb-3"
                        value={selectedRequisition}
                        onChange={handleRequsitionChange}
                      >
                        {requisition.length > 0 ? (
                          requisition.map((item) => (
                            <option key={item._id} value={item._id}>
                              {item.mivNo}
                            </option>
                          ))
                        ) : (
                          <option disabled selected>No records found</option> // Disable the no records option
                        )}
                      </select>
                    </div>

                    <div className="col-xl-4 col-xxl-4">
                      <button className="btn btn-sm btn-primary mt-4" onClick={handleRequisitionForm}>
                        Generate New MIV No.
                      </button>
                    </div>

                  </div>
                </div>
              </div>
            </Collapse>
          </div>
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fa fa-plus me-2" aria-hidden="true"></i>Add MIV Item
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                  onClick={() => setOpen2(!open2)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="table-responsive">
                    <div
                      id="content_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <form>
                        {items.map((item, index) => (
                          <div key={index} className="row">
                            <div className="form-group mb-2 col-md-2">
                              <label>Select Inventory</label>
                              <Select
                                options={partOptions}
                                onChange={(selectedOption) =>
                                  handlePartSelect(index, selectedOption)
                                }
                                placeholder="Part No."
                                menuPortalTarget={document.body}
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minWidth: 90, // increase width (adjust as needed)
                                    height: 14, // increase height (adjust as needed)
                                    fontSize: '12px', // change font size (optional)
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    height: '100%', // ensures the value container aligns with the control height
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    height: 'auto', // allows the input to grow with the control's height
                                  }),
                                }}
                              />
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>Description</label>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                name="description"
                                value={item.description}
                                placeholder="Description"
                              />
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>
                                {item.unit ? `Current Stock (${item.unit})` : `Current Stock`}
                              </label>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                name="currentQty"
                                value={item.currentQty}
                                placeholder="Current Qty"
                              />
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>
                                {item.unit ? `Eligible Quantity (${item.unit})` : `Eligible Quantity`}
                              </label>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                name="eligible"
                                value={item.eligible}
                                placeholder="eligible"
                              />
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>
                                {item.unit ? `Used Quantity (${item.unit})` : `Used Quantity`}
                              </label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="usedQty"
                                value={item.usedQty}
                                onChange={(event) =>
                                  handleItemChange(
                                    index,
                                    "usedQty",
                                    event.target.value
                                  )
                                }
                                placeholder="Used Qty"
                              />
                              <p className="text-danger">{item.error}</p>
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <button
                                className="btn btn-danger btn-xs sharp mt-1"
                                onClick={(e) => handleRemoveItem(e, index)}
                              >
                                <i className="fa fa-trash"></i>
                              </button>
                            </div>
                          </div>
                        ))}
                        <div className="row">
                          <div className="form-group mb-2 col-md-2">
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={(e) => handleAddItem(e)}
                            >
                              Add Item
                            </button>
                          </div>

                          <div className="form-group mb-2 col-md-2">
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={handleSubmit}
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? 'Submitting...' : 'Submit'}
                            </button>

                          </div>
                        </div>
                      </form>
                      <div className="d-sm-flex text-center justify-content-between align-items-center mt-3"></div>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddMivUsedItem;
